import React from "react";
import { Link } from "react-router-dom";

import logo from "../images/logo_light.svg";
import visa from "../images/payment/visa.svg";
import master from "../images/payment/master.svg";

import _1 from "../images/membership/1.svg";
import _2_2x from "../images/membership/2_2x.png";
import _2 from "../images/membership/2.png";
import _3 from "../images/membership/3.png";
import _4 from "../images/membership/4.png";
import _5 from "../images/membership/5.svg";

const Footer = (props) => {
  return (
    <footer id="footer" className="footer-1">
      <div className="main-footer widgets-dark typo-light">
        <div className="container">
          <div className="row footer-row ">
            <div className="column-1 order-2-mobile">
              <div className="widget no-box">
                <h5 className="widget-title">About Us</h5>
                <ul className="thumbnail-widget">
                  <li>
                    <Link to="/about-company">About Company</Link>
                  </li>
                  {props.country !== "AM" && (
                    <li>
                      <a href="https://weprodigi.com/team">Team</a>
                    </li>
                  )}
                  <li>
                    <a href="https://weprodigi.com/contact-us">Contact Us</a>
                  </li>
                  <li>
                    <a href="https://weprodigi.com/payment-terms">
                      Payment Terms
                    </a>
                  </li>
                </ul>
              </div>
              <div className="widget no-box">
                <a
                  href={"https://weprodigi.com/main/cases"}
                  className="widget-title"
                  style={{ textDecoration: "none" }}
                >
                  Portfolio
                </a>
                <ul className="thumbnail-widget">
                  <li>
                    <Link to="/cases">Cases</Link>
                  </li>
                  <li>
                    <Link to="/testimonals">Testimonals</Link>
                  </li>
                </ul>
              </div>
            </div>

            {window.innerWidth > 1000 ? (
              <>
                <div className="column-2  order-2-mobile">
                  <div className="widget no-box">
                    <h5 className="widget-title">Production Services</h5>
                    <ul className="thumbnail-widget">
                      <li>
                        <a href="https://weprodigi.com/video-production">
                          Video Production
                        </a>
                      </li>
                      <li>
                        <a href="https://weprodigi.com/design">
                          Design Services
                        </a>
                      </li>
                      <li>
                        <Link to="/social-media-fun">
                          Branded Game Creation
                        </Link>
                      </li>
                      <li>
                        <Link to="/digital-ad-banners">
                          Digital Banner Production
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="column-2  order-2-mobile">
                  <div className="widget no-box">
                    <h5 className="widget-title">Digital Marketing Services</h5>
                    <ul className="thumbnail-widget">
                      <li>
                        <Link to="https://weprodigi.com/seo/professional-seo-services">
                          Seo Services
                        </Link>
                      </li>
                      <li>
                        <a href="https://weprodigi.com/social-media-marketing">
                          Social Media Marketing
                        </a>
                      </li>
                      <li>
                        <a href="https://weprodigi.com/paid-advertising-services">
                          Paid Advertising Services
                        </a>
                      </li>
                    </ul>
                    <a href="https://weprodigi.com/blog">
                      <h5 className="widget-title">Blog</h5>
                    </a>
                  </div>
                </div>
              </>
            ) : (
              <div className="column-2  order-2-mobile">
                <div className="widget no-box">
                  <h5 className="widget-title">Products</h5>
                  <ul className="thumbnail-widget">
                    <li>
                      <a href="https://weprodigi.com/">Video Production</a>
                    </li>
                    <li>
                      <a href="https://weprodigi.com/social-media-marketing">
                        Social Media Marketing
                      </a>
                    </li>
                    <li>
                      <a href="https://weprodigi.com/seo/professional-seo-services">
                        SEO Services
                      </a>
                    </li>
                    <li>
                      <a href="https://weprodigi.com/paid-advertising-services">
                        Paid Advertising Services
                      </a>
                    </li>
                  </ul>
                  <a href="https://weprodigi.com/blog">
                    <h5 className="widget-title">Blog</h5>
                  </a>
                  <ul className="thumbnail-widget">
                    <li>
                      <ul className="list-inline social-icons-wrap">
                        <li className="list-inline-item">
                          <a
                            className="social-icon"
                            target="_blank"
                            rel="noopener noreferrer nofollow"
                            href="https://www.facebook.com/weprodigi/"
                          >
                            <span className="facebook"></span>
                          </a>
                        </li>
                        <li className="list-inline-item">
                          <a
                            className="social-icon"
                            target="_blank"
                            rel="noopener noreferrer nofollow"
                            href="https://www.instagram.com/weprodigi_agency/"
                          >
                            <span className="instagram"></span>
                          </a>
                        </li>
                        <li className="list-inline-item">
                          <a
                            className="social-icon"
                            target="_blank"
                            rel="noopener noreferrer nofollow"
                            href="https://www.linkedin.com/company/weprodigiagency/"
                          >
                            <span className="linkedin"></span>
                          </a>
                        </li>
                        <li className="list-inline-item">
                          <a
                            className="social-icon"
                            target="_blank"
                            rel="noopener noreferrer nofollow"
                            href="https://www.youtube.com/channel/UC6mkepDFKswxQWS76hgOMBg"
                          >
                            <span className="youtube"></span>
                          </a>
                        </li>
                        <li className="list-inline-item">
                          <a
                            className="social-icon"
                            target="_blank"
                            rel="noopener noreferrer nofollow"
                            href="https://X.com/WeProdigi"
                          >
                            <span className="X"></span>
                          </a>
                        </li>
                      </ul>
                    </li>
                    {/* <li className="d-none d-md-block">
                    <span className="text">
                      <span className="icon-phone"></span>
                      <Phone country={this.props.country}></Phone></span>
                  </li> */}
                    <li className="d-none d-md-block">
                      <span className="text">
                        <span className="icon-email"></span>
                        info@weprodigi.com
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            )}

            <div className="column-3" style={{ marginBottom: "20px" }}>
              <div className="widget no-box">
                {window.innerWidth >= 1000 ? (
                  <img
                    className="logo d-none d-md-block"
                    style={{ marginBottom: "15px" }}
                    src={logo}
                    alt="Logo"
                    height={35}
                    width={98}
                  ></img>
                ) : null}
                {window.innerWidth < 1000 ? (
                  <img
                    className="logo"
                    src={logo}
                    alt="Logo"
                    height={33}
                    width={90}
                  ></img>
                ) : null}

                <h5 className="widget-title d-none d-md-block">Reviews On</h5>
                <ul className="list-inline footer-testimonials d-none d-md-block">
                  <li className="list-inline-item">
                    <a
                      id="footer_google"
                      without="true"
                      rel="noopener noreferrer nofollow"
                      target="_blank"
                      href="https://g.page/prodigi-agency/"
                    >
                      <span className="icon google"></span>
                    </a>
                  </li>
                  <li className="list-inline-item">
                    <a
                      id="footer_clutch"
                      without="true"
                      rel="noopener noreferrer nofollow"
                      target="_blank"
                      href="https://clutch.co/profile/weprodigi-agency"
                    >
                      <span className="icon clutch"></span>
                    </a>
                  </li>
                  <li className="list-inline-item">
                    <a
                      id="footer_facebook"
                      without="true"
                      rel="noopener noreferrer nofollow"
                      target="_blank"
                      href="https://www.facebook.com/weprodigi/reviews/"
                    >
                      <span className="icon facebook"></span>
                    </a>
                  </li>
                </ul>
                <h5 className="widget-title payment-title d-none d-md-block">
                  We accept online payments
                </h5>
                <div className="payment-logos d-none d-md-block ">
                  <img alt="Visa" src={visa} width={70} height={24} />
                  <img alt="Master" src={master} width={145} height={33} />
                </div>
              </div>
            </div>

            <div className="column-5 order-3-mobile d-block d-md-none">
              <h5 className="widget-title payment-title d-block d-md-none">
                We accept online payments
              </h5>
              <div className="payment-logos d-block d-md-none">
                <img alt="Visa" src={visa} width={70} height={24} />
                <img alt="Master" src={master} width={145} height={33} />
              </div>
            </div>

            <div className="column-4 order-2-mobile">
              <div className="container">
                <span className="title">Memberships</span>

                <div className="icons">
                  <div>
                    <span>
                      <img src={_1} alt="american marketing association"></img>
                      <p className="d-none d-md-block">United states</p>
                    </span>
                  </div>
                  <span className="break"></span>
                  <div>
                    <span>
                      <img
                        src={_2}
                        srcSet={`${_2} 1x, ${_2_2x} 2x, ${_2_2x} 3x`}
                        alt="Digital Agency network"
                      ></img>
                      <p>United kingdom</p>
                    </span>
                  </div>
                  <div className="d-none d-md-block">
                    <img src={_3} alt="Top Digital Agency"></img>
                    <p>United states</p>
                  </div>
                  <div className="d-none d-md-block">
                    <img src={_4} alt="Leadership in challenging Times"></img>
                    <p>United states</p>
                  </div>
                  <div>
                    <span>
                      <img src={_5} alt="Ad world"></img>
                      <p>Hong Kong</p>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-copyright">
        <div className="container">
          <div className="row">
            <div className="col-12 text-center">
              <p>
                © {new Date().getFullYear()} | ProDigi - Digital Marketing
                Agency
              </p>
              <a href="privacy">Privacy Policy</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
